import { Controller } from "stimulus";

// Handles finding the span that should contain the local timezone and filling
// it using an instance of JavaScript's Date object
export default class TimeZoneController extends Controller {
  static targets = ["timezone"]

  // used to set state (runs once per controller)
  initialize() {
    try {
      const timezone = new Date()
        .toLocaleTimeString("en-us", { timeZoneName: "short" })
        .split(" ")[2];
      this.timezone = timezone;
    } catch (error) {
      // fallback for IE and very old browsers
      this.timezone = this.constructor.formatTimezoneOffset(new Date().getTimezoneOffset());
    }
  }

  // formats the timezone display for older browsers
  // use static for class methods that don't rely on `this`
  static formatTimezoneOffset(offset) {
    const sign = offset > 0 ? "-" : "+";
    const hours = (Math.abs(offset) < 600 ? "0" : "") + Math.floor(Math.abs(offset) / 60);
    const minutes = (Math.abs(offset) % 60 < 10 ? "0" : "") + (Math.abs(offset) % 60);
    return `UTC${sign}${hours}:${minutes}`;
  }

  // runs whenever controller connects to the DOM element
  connect() {
    this.timezoneTarget.textContent = this.timezone;
  }
}
